<script>
  import {mapActions, mapGetters} from 'vuex';
  import systemsUtils from "../SystemsUtils.js";
  import utils from "../../utils";

  import RenderImagem from 'src/components/utils/RenderImagem'

  export default {
    components: {
      RenderImagem
    },
    computed: {
      ...mapGetters([
        'loggedUser'
      ]),
      businessLineContracts: function () {
        let businessLine = _.find(this.loggedUser.businessLines, {'id': this.$route.params.businessAreaId})
        if (businessLine !== undefined) {
          return businessLine.contracts;
        }
        return [];
      }
    },
    methods: {
      getRandomImage() {
        return 'static/img/ex/img-' + Math.floor(Math.random() * 13) + '.jpg'
      },
      getLogo(id) {
        return systemsUtils.apiUrl() + '/f/systemLogo/' + id
      }
    },
    mounted () {

      if (this.businessLineContracts.length === 1) {
        this.$router.push({
          name: 'ModulesList',
          params: {
            systemId: this.businessLineContracts[0].id,
            systemVersion: this.businessLineContracts[0].version
          }
        });
      } else {
        utils.addBackground(
          utils.getUrlBusinessAreaImage(
            this.$route.params.businessAreaId
          )
        );
      }
    },
    destroyed () {
      utils.removeBackground();
    }
  }

</script>

<style scoped>
  .padding-top-10px{
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .fundo-transparente {
    background-color: rgba(4, 6, 9, 0.3);
    min-height: 290px;
  }
  .padding-30px-margintop-50px{
    padding: 30px;
    margin: 50px 0 !important;
  }
  @media (min-width: 300px) {
    .padding-30px-margintop-50px  {
      padding: 0px 20px 40px 20px;
    }
    @media (min-width: 450px) {
      .padding-30px-margintop-50px {
        padding: 30px !important;
      }
    }
  }
  @media (min-width: 1200px) {
    .col-lg-2 {
      width: 25% !important;
    }
    @media (min-width: 1400px) {
      .col-lg-2 {
        width: 16.66667% !important;
      }
    }
  }

</style>

<template>
  <div slot="body" v-if="businessLineContracts.length > 1">
    <div class="row fundo-transparente padding-30px-margintop-50px">

      <div v-for="row in businessLineContracts"
           :offset="index > 0 ? 2 : 0"
           class="col-xs-12 col-sm-6 col-md-3 col-lg-2 padding-top-10px">
        <RenderImagem
          height="height: 200px;"
          :router="{ name: 'ModulesList', params: { systemId: row.id, systemVersion: row.version } }"
          :label="row.labelPt"
          :src="getLogo(row.id)"
        />
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// SystemsList.vue?0477d505